import { css } from 'styled-components';

export const boxShadow = css`
  box-shadow: var(--shadow-3);
`;
